<template>
  <div class="righthead">
    <div class="userinfo" @click="showxiala">{{login_id}}</div>
    <div class="logout" @click="user_logout" v-if="showbtn">退出登录</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nickname: "管理后台",
      showbtn: false,
      login_id: sessionStorage.getItem("username")
    };
  },
  methods: {
    showxiala() {
      this.showbtn = !this.showbtn;
      console.log(sessionStorage.getItem("username"));
    },
    user_logout() {
      sessionStorage.removeItem("username");
      sessionStorage.removeItem("passwd");
      this.$router.push({ path: "/" });
    }
  },
  computed: {
    token() {
      return sessionStorage.getItem("username");
    }
  }
};
</script>


<style  scoped>
.righthead {
  height: 64px;
  background: #2c3e50;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  position: relative;
  z-index: 1;
  color: #e6f7ff;
}
.userinfo {
  width: 120px;
  float: right;
  height: 64px;
  line-height: 64px;
  cursor: pointer;
}
.logout {
  width: 120px;
  height: 64px;
  line-height: 64px;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 64px;
  color: white;
  background: #f56c6c;
}
</style>




// WEBPACK FOOTER //
// src/xxxvue/Headerlg.vue